import { registerSW } from 'virtual:pwa-register'

/**
 * PWA 更新策略
 *
 * 背景：使用 `registerType: 'autoUpdate'` 时，vite-plugin-pwa 默认只会静默
 * 激活新的 Service Worker，但不会刷新当前页面——这导致用户必须关闭再重新打开
 * 应用，才能拿到最新的 HTML / JS bundle。
 *
 * 这里接管注册流程：
 * 1. `onNeedRefresh`：检测到新 SW 处于 waiting 状态时，立即调用
 *    `updateSW(true)` → 触发 skipWaiting，让新 SW 取得控制权。
 * 2. `onRegisteredSW`：每小时主动检查一次更新，保证长时间停留的 PWA 用户也
 *    能及时发现新版。
 * 3. `controllerchange` 事件：一旦新 SW 成为控制者，立即 reload 当前页面，
 *    从而加载最新的 index.html + 新 hash 的 JS bundle。
 */
export function initPwa(): void {
  if (typeof window === 'undefined') {
    return
  }
  if (!('serviceWorker' in navigator)) {
    return
  }

  let reloading = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) {
      return
    }
    reloading = true
    window.location.reload()
  })

  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      // 新版本已下载并进入 waiting，立即激活；
      // 激活后 controllerchange 会触发上面的 reload。
      void updateSW(true)
    },
    onRegisteredSW(_swUrl, registration) {
      if (!registration) {
        return
      }
      // 每小时拉一次 SW 脚本，后端如有更新则会进入 waiting → onNeedRefresh。
      setInterval(
        () => {
          void registration.update()
        },
        60 * 60 * 1000,
      )
    },
  })
}
